// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ContractCompanyItemResponse

export type ContractCompanyItemApiResponse = {
	name: string;
	siren: string;
	siret: string;
	address: string;
	zipCode: string;
	city: string;
	vatNumber: string;
};

export type ContractCompanyItem = {
	name: string;
	siren: string;
	siret: string;
	address: string;
	zipCode: string;
	city: string;
	vatNumber: string;
};

export function hydrateContractCompanyItem(data: ContractCompanyItemApiResponse): ContractCompanyItem {
	return { ...data };
}